<template>
  <div
    v-if="varietyPack"
    class="flex flex-col gap-4"
  >
    <div
      v-if="contents"
      class="flex flex-col gap-2"
    >
      <h3 class="font-bold">
        What's in this bundle?
      </h3>
      <div class="grid grid-cols-3 xs:grid-cols-4 sm:grid-cols-5 md:grid-cols-6 gap-2">
        <a
          v-for="(entry, index) in contents"
          :key="index"
          :href="$url(`/products/${entry.product.handle}`)"
          class="product-card +small text-center text-sm"
        >
          <ResponsiveImage
            v-if="entry.product?.profileImage"
            :width="96"
            :image="entry.product.profileImage"
            class="w-24"
          />
          <div class="absolute top-1 right-1 flex-center rounded-full bg-white border border-neutral-200 w-6 h-6 font-bold">
            <div class="text-gray-700">
              {{ entry.quantity }}
            </div>
          </div>
          <div class="flex grow items-start font-medium">
            {{ entry.product.shortTitle?.length ? entry.product.shortTitle : entry.product.title }}
          </div>
        </a>
      </div>
    </div>
    <div class="flex-center py-4">
      <button
        class="button +green +large grow max-w-sm"
        data-gtm-action="fill box"
        :data-gtm-label="varietyPack.title"
        @click="handleClick"
      >
        Fill Box
      </button>
    </div>
  </div>
  <VueModal
    v-if="varietyPack"
    v-model="confirm"
    @close="confirm = false"
  >
    <div class="modal-content">
      <h2 class="modal-title">
        <span class="text-lg">
          {{ $t('bundler.not_enough_room') }}
        </span>
      </h2>
      <p>
        {{ $t('bundler.replace_selections') }}
      </p>
      <div class="flex flex-col gap-2">
        <button
          class="button +green"
          data-gtm-action="replace box"
          @click="fillBox"
        >
          {{ $t('bundler.replace_box') }}
        </button>
        <button
          class="button +white"
          data-gtm-action="edit box"
          @click="confirm = false"
        >
          {{ $t('bundler.keep_selections') }}
        </button>
      </div>
    </div>
  </VueModal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useBundleStore, useVarietyPacksStore } from '@/stores'
import { showBundleSummary } from '@/utils/bundle'
import VueModal from '@/components/theme/render/vue-modal.vue'
import ResponsiveImage from '../shared/v2/responsive-image.vue'
const packsStore = useVarietyPacksStore()
const bundleStore = useBundleStore()
const { varietyPack } = storeToRefs(packsStore)
const { selectedSize, totalQuantity } = storeToRefs(bundleStore)
const confirm = ref(false)
const contents = computed(() => packsStore.contents(varietyPack.value, selectedSize.value))

const handleClick = () => {
  if (selectedSize.value + totalQuantity.value > 24) {
    confirm.value = true
  } else {
    fillBox()
  }
}

const fillBox = () => {
  confirm.value = false
  bundleStore.selection = Object.fromEntries((contents.value || []).map(i => [ i.product?.key, i.quantity ]))
  showBundleSummary()
}
</script>
